// extracted by mini-css-extract-plugin
export default {"Container":"denied_Container__-19CK","modal":"denied_modal__vh7iy","bounce":"denied_bounce__Cm56Z","overlay":"denied_overlay__wiFs0","wrapper":"denied_wrapper__U-XAE"};